var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_14",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5568 9.81819H12.375V14.4546H18.8114C18.2114 17.4 15.7023 19.0909 12.375 19.0909C8.44773 19.0909 5.28409 15.9273 5.28409 12C5.28409 8.07273 8.44773 4.90909 12.375 4.90909C14.0659 4.90909 15.5932 5.50909 16.7932 6.49091L20.2841 3C18.1568 1.14545 15.4296 0 12.375 0C5.72046 0 0.375 5.34546 0.375 12C0.375 18.6546 5.72046 24 12.375 24C18.375 24 23.8296 19.6364 23.8296 12C23.8296 11.2909 23.7205 10.5273 23.5568 9.81819Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.715942 19.0909V4.90909L8.55679 12L-0.715942 19.0909Z",
    fill: "#FBBC05"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_24_14",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5568 9.81819H12.375V14.4546H18.8114C18.2114 17.4 15.7023 19.0909 12.375 19.0909C8.44773 19.0909 5.28409 15.9273 5.28409 12C5.28409 8.07273 8.44773 4.90909 12.375 4.90909C14.0659 4.90909 15.5932 5.50909 16.7932 6.49091L20.2841 3C18.1568 1.14545 15.4296 0 12.375 0C5.72046 0 0.375 5.34546 0.375 12C0.375 18.6546 5.72046 24 12.375 24C18.375 24 23.8296 19.6364 23.8296 12C23.8296 11.2909 23.7205 10.5273 23.5568 9.81819Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_24_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.715942 4.90909L8.55679 12L12.375 8.67273L25.4659 6.54545V-1.09091H-0.715942V4.90909Z",
    fill: "#EA4335"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_24_14",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5568 9.81819H12.375V14.4546H18.8114C18.2114 17.4 15.7023 19.0909 12.375 19.0909C8.44773 19.0909 5.28409 15.9273 5.28409 12C5.28409 8.07273 8.44773 4.90909 12.375 4.90909C14.0659 4.90909 15.5932 5.50909 16.7932 6.49091L20.2841 3C18.1568 1.14545 15.4296 0 12.375 0C5.72046 0 0.375 5.34546 0.375 12C0.375 18.6546 5.72046 24 12.375 24C18.375 24 23.8296 19.6364 23.8296 12C23.8296 11.2909 23.7205 10.5273 23.5568 9.81819Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_24_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.715942 19.0909L15.6477 6.54545L19.9568 7.09091L25.4659 -1.09091V25.0909H-0.715942V19.0909Z",
    fill: "#34A853"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_24_14",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5568 9.81819H12.375V14.4546H18.8114C18.2114 17.4 15.7023 19.0909 12.375 19.0909C8.44773 19.0909 5.28409 15.9273 5.28409 12C5.28409 8.07273 8.44773 4.90909 12.375 4.90909C14.0659 4.90909 15.5932 5.50909 16.7932 6.49091L20.2841 3C18.1568 1.14545 15.4296 0 12.375 0C5.72046 0 0.375 5.34546 0.375 12C0.375 18.6546 5.72046 24 12.375 24C18.375 24 23.8296 19.6364 23.8296 12C23.8296 11.2909 23.7205 10.5273 23.5568 9.81819Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_24_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4659 25.0909L8.55682 12L6.375 10.3636L25.4659 4.90909V25.0909Z",
    fill: "#4285F4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.fc40d321a3cc20d067af60c05c496b2c.svg";
export { ForwardRef as ReactComponent };